import { render, staticRenderFns } from "./gameList.vue?vue&type=template&id=34311776&"
import script from "./gameList.vue?vue&type=script&lang=js&"
export * from "./gameList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports